export default __webpack_public_path__ + "static/media/blog_banner.05b3589c.png";